import {useMemo} from "react";
import {isEmpty} from "lodash";
import {useSelector} from "react-redux";
import {usePermissionCheck} from "../../components/protectedContent";
import {getSelectedLocations} from "../../redux/Selectors/sites.selectors";
import TabList from "./siteTabs";

const useGetTabList = () => {
  const canViewInventory = usePermissionCheck(["view_systeminventory"]);
  const selectedLocation = useSelector(getSelectedLocations);
  const tabList = useMemo(() => {
    if (isEmpty(selectedLocation)) {
      return TabList.filter((each) => {
        if (each.name === "Map") {
          return true;
        } else if (canViewInventory && each.name === "Site Appliances") {
          return true;
        }
        return false;
      });
    } else {
      return TabList.filter((each) => {
        if (each.name === "Location") {
          return true;
        } else if (canViewInventory && each.name === "Appliances") {
          return true;
        }
        return false;
      });
    }
  }, [canViewInventory, selectedLocation]);

  return {tabList};
};

export default useGetTabList;
